import React, { useState } from 'react'
import classNames from 'classnames'
import { Formik, Field } from 'formik'
import { isEqual, startCase } from 'lodash'
import { IconAdjustments } from '@tabler/icons-react'

import { CreatableInput } from '@/components/forms/CreatableInput'
import { BasicModal } from '@/components/layout/modals/BasicModal'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'
import { RadioGroup } from '@/components/forms/formik'
import { initialState } from '@/reducers/callSearch/callSearch.redux'
import { Button } from '@/components/buttons/Button'
import { FormField } from '@/components/forms/FormField'

import './KeywordSearch.scss'

export const KeywordSearch = ({ handleUpdateFilters, filters }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const filtersHaveBeenApplied = !isEqual(
    filters.keywordOptions,
    initialState.filters.keywordOptions
  )

  const handleClose = () => setModalOpen(false)

  const handleUpdateKeywordOptions = (values) => {
    handleUpdateFilters('keywordOptions', values)
    handleClose()
  }

  return (
    <>
      <FormField data-testid="keyword-filter">
        <label>Keywords</label>
        <div className="keyword-search-container flex-align-start medium-gap">
          <CreatableInput
            nameKey="keywords"
            placeholder="Enter keywords..."
            value={filters.keywords}
            handleUpdateFilters={handleUpdateFilters}
          />
          <InteractiveTooltip
            placement="bottom"
            content={
              <div className="text-left">
                <div className="flex small-gap">
                  <strong>Search Logic:</strong>
                  <span>{startCase(filters.keywordOptions.logic)}</span>
                </div>
                <div className="flex small-gap">
                  <strong>Side:</strong>
                  <span>{startCase(filters.keywordOptions.side)}</span>
                </div>
              </div>
            }
          >
            <Button
              square
              onClick={() => setModalOpen(true)}
              className={classNames({ 'filters-applied': filtersHaveBeenApplied })}
            >
              <IconAdjustments />
            </Button>
          </InteractiveTooltip>
        </div>
      </FormField>

      {modalOpen && (
        <BasicModal
          title="Advanced Keyword Search"
          onClose={() => setModalOpen(false)}
          show={modalOpen}
          size="tiny"
        >
          <Formik initialValues={filters.keywordOptions} onSubmit={handleUpdateKeywordOptions}>
            {({ handleSubmit }) => (
              <div className="field-stack">
                <Field
                  name="logic"
                  label="Search Logic"
                  component={RadioGroup}
                  options={[
                    { label: 'And', value: 'and' },
                    { label: 'Or', value: 'or' },
                  ]}
                />
                <Field
                  name="side"
                  label="Side"
                  component={RadioGroup}
                  options={[
                    { label: 'Me', value: 'me' },
                    { label: 'Them', value: 'them' },
                    { label: 'Both', value: 'both' },
                  ]}
                />
                <div className="modal-footer">
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button brand onClick={handleSubmit}>
                    Apply
                  </Button>
                </div>
              </div>
            )}
          </Formik>
        </BasicModal>
      )}
    </>
  )
}
